var $ = require('./lib/jquery-2.2.1.js');  // **注意，这里请修改jquery的正确地址，重要！**
module.exports = $;


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/wangeditor/js/wangEditor-jquery.js
 ** module id = 15
 ** module chunks = 0
 **/